import { Box, Chip, Dialog, DialogContent, Typography } from "@mui/material";
import React from "react";

const ComplilationModal = ({ open, onClose, message }) => {
  return (
    <Dialog open={open} maxWidth={"sm"} fullWidth>
      <DialogContent>
        <Box display={"flex"} flexDirection={"column"} gap={"1.5rem"}>
          <Typography>{message}</Typography>
          <Box display={"flex"} gap={"1rem"}>
            <Chip
              label={"Close"}
              variant="outlined"
              color="primary"
              onClick={onClose}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ComplilationModal;
